import { LineChartWrapper } from '../charts/LineChart'
import { formatMoney } from '../format'
import { buildDrillRsql } from '../drill'
import { WidgetFrame } from './WidgetFrame'
import { useWidgetData } from './useWidgetData'
import { WIDGET_KEY, type WidgetProps } from './types'
import type { SpendTrendBucket } from '../../../types/insights'

const WIDGET_KEY_SELF = WIDGET_KEY.qreSpendTrend

/** AC5 — QRE / qualified-spend trend. */
export function SpendTrendWidget({ filter, skipRefetch, onDrill }: WidgetProps) {
  const { status, data, message, retry } = useWidgetData<SpendTrendBucket[]>(WIDGET_KEY_SELF, filter, skipRefetch)

  const rows = data ?? []
  const currency = rows[0]?.currency ?? 'USD'
  const frameState = status === 'ok' && rows.length === 0 ? 'empty' : status

  return (
    <WidgetFrame
      title="Qualified-spend trend"
      icon="activity"
      state={frameState}
      message={message}
      onRetry={retry}
      drill={{ label: 'View filings', onClick: () => onDrill(buildDrillRsql(filter)) }}
    >
      <LineChartWrapper
        title="Qualified-spend trend"
        data={rows}
        categoryKey="fiscalYearLabel"
        categoryLabel="Fiscal year"
        series={[{ key: 'amount', label: 'Qualified spend' }]}
        valueFormatter={(v) => formatMoney(String(v), currency)}
      />
    </WidgetFrame>
  )
}
